<template>
  <el-button
      class="btn"
      size="mini"
      plain
      type="primary"
      slot="trigger"
      @click="pickMaterial">
    素材库
    <MaterialPickModal
        :materialType="materialType"
        :show="show"
        @onConfirmPickMaterial="onConfirmPickMaterial"
    ></MaterialPickModal>
  </el-button>

</template>

<script>
import AppPagination from "@/components/ui/AppPagination/AppPagination";
import MaterialPickModal from "@/pages/MaterialCenter/components/MaterialPickModal.vue";
import {mapMutations} from "vuex";

export default {
  name: "MaterialPicker",
  components: {MaterialPickModal, AppPagination},
  props: {
    materialType: {
      type: String,
      default() {
        return "image";
      },
    },
  },
  data() {
    return {
      show: {
        show: false
      },
    }
  },
  created() {
  },
  computed: {},
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    onConfirmPickMaterial(item) {
      this.$emit("onConfirmPickMaterial", item);
    },
    pickMaterial(event) {
      this.show.show = true;
      event.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
